import React from "react";
import Icon from "@mdi/react";
import { mdiPlay } from "@mdi/js";
import Text from "../typography/Text";

const Youtube = ({ link, duration }) => {
  if (!link) return null;
  return (
    <div className="file" onClick={() => window.open(link, "_blank")}>
      <div className="file_icon -outlined">
        <Icon path={mdiPlay} size="18px" color="#ff4d3b" />
      </div>
      <div className="file_meta">
        <h5>Youtube</h5>
        <Text small>{duration}</Text>
      </div>
    </div>
  );
};

export default Youtube;
